import { Component, EventEmitter, Input, Output } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';

import {
    StaticInfoFieldMenuCategory,
    StaticInfoFieldMenuItem,
} from 'Angular/services/static-menus/interfaces/static-info-field-menu.interface';

import { InfoFieldSelectorModalDirective } from 'SecuritiesApp/ts/info-field-selector-modals/info-field-selector-modal/info-field-selector-modal.directive';

/**
 * Multi Info Field Selector Modal Component
 *
 * Modal that shows the static menu of info fields and allows user to select multiple info fields at once.
 *
 * Input Properties:
 *  infoType: 'company', 'fund', 'all', etc.
 * defaultOnly: info needed for context aware data source filtering
 *
 * Output Properties:
 *  selectInfoFieldHandler: emits a list containing the info fields that were selected.
 */
@Component({
    standalone: false,
    selector: 'ycn-multi-info-field-selector-modal',
    templateUrl: './multi-info-field-selector-modal.template.html',
})
export class MultiInfoFieldSelectorModalComponent extends InfoFieldSelectorModalDirective {
    @Output() selectInfoFieldsHandler = new EventEmitter<StaticInfoFieldMenuItem[]>();

    @Input() categories?: StaticInfoFieldMenuCategory[];

    @Input() fetchCategories?: boolean;

    @Input() defaultOnly: boolean = false;

    openModal(): void {
        this.modalOpen = true;
    }

    closeModal(): void {
        this.modalOpen = false;
        this.resetModal();
    }

    selectInfoField(selectedInfoField: StaticInfoFieldMenuItem): void {
        // Make a copy because InfoFieldListComponent.ngOnChanges won't fire when mutating the existing list
        const newSelectedInfoFields = cloneDeep(this.selectedInfoFields);
        const idx = newSelectedInfoFields.findIndex((infoField) => infoField.key === selectedInfoField.key);

        if (idx === -1) {
            newSelectedInfoFields.push(selectedInfoField);
        } else {
            newSelectedInfoFields.splice(idx, 1);
        }

        this.selectedInfoFields = newSelectedInfoFields;
    }

    submitInfoFields(): void {
        this.selectInfoFieldsHandler.emit(
            this.featureService.validateFeatureNeeded(this.selectedInfoFields, this.featureNeededModal)
        );
        this.closeModal();
    }
}
